import router from '~router'
import {
  setToken,
  unsetToken
} from '~utils/auth'
import {
  postStudentLogin,
  postStudentSignup,
  postStudentRegister,
  getStudentLogout,
  postStudentForgetPassword,
  postStudentResetPassword,
} from '~api/students'

import {
  postEnterpriseLogin,
  postEnterpriseSignup,
  postEnterpriseRegister,
  getEnterpriseLogout,
  postEnterpriseForgetPassword,
  postEnterpriseResetPassword,
} from '~api/enterprises'

import {
  postTeacherLogin,
  getTeacherLogout,
} from '~api/teachers'

export const state = () => ({
  currentUser: {
    token: '',
    token_expired_at: '',
    type: 'anonymous'
  }
})

export const getters = {
  tokenGetters: state => state.currentUser.token,
  isAuthenticatedGetter: state => state.currentUser.token,
  isStudentGetter: state => state.currentUser.type === 'student',
  isEnterpriseGetter: state => state.currentUser.type === 'enterprise',
  isTeacherGetter: state => state.currentUser.type === 'teacher',
  isAnonymousGetter: state => state.currentUser.type === 'anonymous',
  userTypeGetter: state => state.currentUser.type
}

export const actions = {
  async userLogout ({ commit, dispatch }, type) {
    dispatch(`pages/${type}s/logout`, null, { root: true })
    let response;
    switch(type) {
      case 'student': response = await getStudentLogout(); break;
      case 'enterprise': response = await getEnterpriseLogout(); break;
      case 'teacher': response = await getTeacherLogout(); break;
    }
    commit('resetCurrentUser', { type })
    router.replace({
      name: 'Home'
    })
    return response
  },
  async userLogin ({ commit }, {
    type,
    data
  }) {
    let response;
    switch(type) {
      case 'student': response = await postStudentLogin(data); break;
      case 'enterprise': response = await postEnterpriseLogin(data); break;
      case 'teacher': response = await postTeacherLogin(data); break;
    }
    commit('setCurrentUser', {
      type,
      response
    })


  let historyRoute = sessionStorage.getItem('qrRoute');
  let previousRoute = sessionStorage.getItem('previousRouteName');

  if (previousRoute !== null){
    
    let previousRouteQuery = JSON.parse(sessionStorage.getItem('previousRouteQuery'));
    sessionStorage.removeItem('previousRouteName');
    sessionStorage.removeItem('previousRouteQuery');

    router.replace({
      name: previousRoute,
      params: previousRouteQuery
    })

  }else if (historyRoute !== null){
    // 先清除紀錄在引導過去
    sessionStorage.removeItem('qrRoute');

    router.push({
      name: 'Point',
      query: {
        qrcode: JSON.stringify(historyRoute)
      }
    })
  }else{
     switch(type) {
       case 'student': router.replace({ name: 'Students' }); break;
       case 'enterprise': router.replace({ name: 'Enterprises' }); break;
       case 'teacher': router.replace({ name: 'Teachers' }); break;
       default: router.replace({ name: 'Home' }); break;
     }
     return response
  }


  },
  async userSignUp ({}, { type, account }) {
    const response = type === 'student' ? await postStudentSignup(account) : await postEnterpriseSignup(account)
    return response
  },
  async addUserProfile ({}, { type, profile }) {
    const response = type === 'student' ? await postStudentRegister(profile) : await postEnterpriseRegister(profile)
    return response
  },
  updateUserToken ({ commit }, { token, expires }) {
    const bearerToken = token.split(' ')[1]
    commit('resetUserToken', { bearerToken, expires })
  },
  async userForgetPassword ({}, { type, account }) {
    const response = type === 'student' ? await postStudentForgetPassword(account) : await postEnterpriseForgetPassword(account)
    return response
  },
  async userResetPassword ({}, { type, params }) {
    const response = type === 'student' ? await postStudentResetPassword(params) : await postEnterpriseResetPassword(params)
    return response
  },
  async checkStudentAuth ({ getters }) {
    return getters.isStudentGetter
  },
  async checkEnterpriseAuth ({ getters }) {
    return getters.isEnterpriseGetter
  },
}

export const mutations = {
  resetCurrentUser (state, payload) {
    state.currentUser = {
      token: '',
      token_expired_at: '',
      type: 'anonymous'
    }
    unsetToken(payload)
  },
  setCurrentUser (state, payload) {
    state.currentUser = { ...payload.response, ...{ type: payload.type } }
    setToken({ ...payload.response, ...{ type: payload.type } })
  },
  resetUserToken (state, payload) {
    state.currentUser = Object.assign({}, state.currentUser, {
      token: payload.bearerToken
    })
    setToken({
      token: payload.bearerToken,
      token_expired_at: payload.expires,
      type: state.currentUser.type
    })
  }
}
